<template>
  <!-- Progressive disclosure: md shows Perf Tools + Search, lg adds Dashboard, xl shows all -->
  <div id="header-links" class="hidden md:flex relative ml-auto items-baseline gap-4">
    <router-link
      v-if="!isSettingViewOnly"
      :to="{ name: isLiveDashboardEnabled ? 'reservationsDashboardLive' : 'reservationsDashboard' }"
      id="venue-dashboard"
      class="link text-fg-link-primary text-base font-normal hidden lg:block"
    >
      Dashboard
    </router-link>
    <PerformanceToolsLink
      v-if="!isSettingViewOnly"
      id="venue-performance-tools"
      class="link text-fg-link-primary text-base font-normal"
    >
      Performance Tools
    </PerformanceToolsLink>
    <router-link
      v-if="!isSettingViewOnly"
      :to="{ name: RESIDENCY_ROUTE_NAMES.LIST }"
      id="venue-residencies"
      class="link text-fg-link-primary text-base font-normal hidden xl:block"
    >
      Residencies
    </router-link>
    <template v-if="!isSettingViewOnly">
      <router-link
        v-if="!isShowsV3Enabled"
        :to="{ name: SHOW_ROUTE_NAMES.LIST }"
        id="venue-shows"
        class="link text-fg-link-primary text-base font-normal hidden xl:block"
      >
        Shows
      </router-link>
      <router-link
        v-else
        :to="{ name: SHOWS_ROUTE_NAMES.LIST }"
        id="venue-shows"
        class="header-link text-fg-link-primary text-base font-normal hidden xl:block"
        >Shows (beta)</router-link
      >
    </template>
    <template v-if="isOwner">
      <router-link
        v-if="!isSettingViewOnly"
        :to="{ name: MAILCHIMP_ROUTE_NAMES.TEMPLATE_EDIT }"
        id="mailchimp-template-edit"
        class="link text-fg-link-primary text-base font-normal hidden xl:block"
      >
        Marketing
      </router-link>
      <router-link
        v-if="!isSettingViewOnly"
        :to="{ name: 'reportsOverview' }"
        id="venue-reports"
        class="link text-fg-link-primary text-base font-normal hidden xl:block"
      >
        Reports
      </router-link>
    </template>
    <VenueSearchMenu class="mr-4" />
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'

import { useFeatureFlags } from '@/common/composables/useFeatureFlags'
import { MAILCHIMP_ROUTE_NAMES } from '@/modules/mailchimp/constants/MailchimpRouteNames'
import PerformanceToolsLink from '@/modules/performance/components/atoms/PerformanceToolsLink.vue'
import { RESIDENCY_ROUTE_NAMES } from '@/modules/residency/constants/ResidencyRouteNames'
import { SHOWS_ROUTE_NAMES, SHOW_ROUTE_NAMES } from '@/modules/show/constants/ShowRouteName'
import VenueSearchMenu from '@/modules/venueUi/components/organisms/VenueSearchMenu.vue'
import { useSettingStore } from '@/stores/setting'
import { useUserStore } from '@/stores/user'

const settingStore = useSettingStore()
const { isSettingViewOnly } = storeToRefs(settingStore)

const userStore = useUserStore()
const { isOwner } = storeToRefs(userStore)

const { isShowsV3Enabled, isLiveDashboardEnabled } = useFeatureFlags()
</script>
